import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-43a036cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = ["href"]

import { onMounted, ref, Ref } from 'vue';
 import RoadmapService from '@/services/RoadmapService';
 import RoadmapInterface from '@/interfaces/RoadmapInterface';
 
 
export default /*#__PURE__*/_defineComponent({
  __name: 'RoadMapBar',
  setup(__props) {

 const roadmaps: Ref<Array<RoadmapInterface>> = ref([]);
 const filteredRoadmaps: Ref<Array<RoadmapInterface>> = ref([]);
 const currentBanner = ref({});
 const roadmapService = new RoadmapService();
 let currentBannerIndex = 0;
 
 const changeBanner = () => {
   currentBannerIndex = (currentBannerIndex + 1) % filteredRoadmaps.value.length;
   currentBanner.value = filteredRoadmaps.value[currentBannerIndex];
 };
 
 onMounted(async () => {
   roadmaps.value = await roadmapService.GetAllRoadmaps();
   filteredRoadmaps.value = roadmaps.value;
   if (filteredRoadmaps.value.length > 0) {
     currentBanner.value = filteredRoadmaps.value[currentBannerIndex];
     setInterval(changeBanner, 12000); // Cambiar cada 12 segundos
   }
 });
 
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg-image",
      style: _normalizeStyle({ 'background-image': `url(${currentBanner.value.image_url})` , 'filter': 'blur(50px)', 'background-size': 'cover'})
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(currentBanner.value.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", null, _toDisplayString(currentBanner.value.description), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        class: "button acc",
        href: `itinerarios-formativos/${currentBanner.value.id}`
      }, "Acceder", 8, _hoisted_5)
    ])
  ]))
}
}

})